import React from 'react';

import Clear from 'material-ui/svg-icons/content/clear';
import IconButton from 'material-ui/IconButton';

const ClearButton = ({ handleClick = () => {}, style = {} }) => (
  <IconButton onClick={handleClick} style={style}>
    <Clear />
  </IconButton>
);

export default ClearButton;



// WEBPACK FOOTER //
// ./src/components/Book/SelectedShifts/ClearButton.js